import {
  PairedTowerPaymentsDevice,
  PaymentMethod,
} from "@towersystems/roam-common/lib/generated-types";
import React from "react";

export const ScreenContext = React.createContext<
  | {
      paymentMethod?: PaymentMethod;
      pairedDevice?: PairedTowerPaymentsDevice | undefined;
      isValidConnection?: boolean | undefined;
      refresh: (reset?: boolean) => Promise<void>;
    }
  | undefined
>(undefined);
